export default {
    namespaced: true,
    state: () => ({
        id: 0,
        name: 'guest',
        email: 'guest@example.com',
        locale: window.default_locale,
        is_logged_in: false,
        tfa_type: '',
        is_tfa_enabled: false,
        is_company_tfa_enabled: false,
        is_association_tfa_enabled: false,
        tfa_processed: false,
        is_change_password: false,
        is_multi_association_access: false,
        module_state: false,
        modules: {
            claimsvault: false,
            covervault: false,
            cia: false,
            default: null,
        },
        association: {
            id: 0,
            name: '',
            logo: null,
            expiration_date: null,
        },
        company: {
            id: 0,
            name: '',
            company_code: '',
        },
        abilities: [],
        association_list: [],
        current_association: {
            id: 0,
            name: '',
            logo: null,
            is_setup: false,
            expiration_date: null,
        },
        current_company: {
            id: 0,
            name: '',
            is_setup: false,
        },
        claimsvault_analytics_url: '',
        covervault_analytics_url: '',
        roles: [],
    }),
    mutations: {
        setIsLoggedIn(state, flag) {
            state.is_logged_in = flag;
        },
        setUser(state, user) {
            state.id = user.id;
            state.email = user.email;
            state.locale = user.locale;
            state.name = user.name;
            state.is_logged_in = user.is_logged_in;
            state.tfa_type = user.tfa_type;
            state.is_tfa_enabled = user.is_tfa_enabled;
            state.is_company_tfa_enabled = user.is_company_tfa_enabled;
            state.is_association_tfa_enabled = user.is_association_tfa_enabled;
            state.tfa_processed = user.tfa_processed;
            state.is_change_password = user.is_change_password;
            state.is_multi_association_access = user.is_multi_association_access;
            state.association = user.association;
            state.company = user.company;
            state.abilities = user.abilities;
            state.association_list = user.association_list;
            state.module_state = user.module_state;
            state.modules = user.modules;
            state.default_landing_page = user.default_landing_page;
            state.claimsvault_analytics_url = user.claimsvault_analytics_url;
            state.covervault_analytics_url = user.covervault_analytics_url;
            state.enable_advanced_claims_analytics = user.enable_advanced_claims_analytics;
            state.enable_advanced_cover_analytics = user.enable_advanced_cover_analytics;
            state.claims_detail_layout = user.claims_detail_layout;
            state.roles = user.roles;

            if (user.clear_current_association !== undefined && user.clear_current_association === true) {
                state.current_association.id = 0;
                state.current_association.name = '';
                state.current_association.logo = null;
                state.current_association.is_setup = false;
                state.current_association.expiration_date = null;

                state.current_company.id = 0;
                state.current_company.name = '';
                state.current_company.is_setup = false;
            } else if (!state.current_association.is_setup) {
                state.current_association.id = user.association.id;
                state.current_association.name = user.association.name;
                state.current_association.logo = user.association.logo;
                state.current_association.is_setup = true;
                state.current_association.expiration_date = user.association.expiration_date;

                if (user.company.id !== undefined) {
                    state.current_company.id = user.company.id;
                    state.current_company.name = user.company.name;
                    state.current_company.is_setup = true;
                } else {
                    state.current_company.id = 0;
                    state.current_company.name = '';
                    state.current_company.is_setup = false;
                }
            }

            if (user.association_list.length > 1) {
                state.modules = {
                    ...state.modules,
                    ...user.association_list.find((x) => x.id == state.current_association.id).modules,
                };
            }
        },
        setTFA(state, data) {
            state.tfa_type = data.tfa_type;
            state.is_tfa_enabled = data.is_tfa_enabled;
        },
        setTFAProcessed(state, tfa_processed) {
            state.tfa_processed = tfa_processed;
        },
        setPasswordExpiry(state, is_change_password) {
            state.is_change_password = is_change_password;
        },
        setCurrentAssociation(state, data) {
            state.current_association.id = data.id;
            state.current_association.name = data.name;
            state.current_association.logo = data.logo;
            state.current_association.is_setup = true;
            state.current_association.expiration_date = data.expiration_date;

            if (data.company.id !== undefined) {
                state.current_company.id = data.company.id;
                state.current_company.name = data.company.name;
                state.current_company.is_setup = true;
            } else {
                state.current_company.id = 0;
                state.current_company.name = '';
                state.current_company.is_setup = false;
            }
        },
    },
    getters: {
        locale(state) {
            return state.locale ? state.locale : window.default_locale;
        },
        name(state) {
            return state.name;
        },
        associationId(state) {
            return state.association.id;
        },
        claimsvaultAnalyticsUrl(state) {
            return state.claimsvault_analytics_url;
        },
        covervaultAnalyticsUrl(state) {
            return state.covervault_analytics_url;
        },
        currentAssociationId(state) {
            return state.current_association.id;
        },
        currentAssociationName(state) {
            return state.current_association.name;
        },
        currentAssociationLogo(state) {
            return state.current_association.logo;
        },
        currentCompanyId(state) {
            return state.current_company.id;
        },
        currentCompanyName(state) {
            return state.current_company.name;
        },
        companyName(state) {
            return state.company.name;
        },
        companyId(state) {
            return state.company.id;
        },
        isMultiAssociation(state) {
            return state.is_multi_association_access;
        },
        multiAssociationList(state) {
            return state.association_list;
        },
        isModulesEnabled() {
            return state.module_state;
        },
        modules() {
            return state.modules;
        },
    },
    actions: {
        forceLogin({ commit }) {
            commit('setIsLoggedIn', false);
        },
        updateUser({ commit }, payload) {
            commit('setUser', payload);
        },
        updateTFA({ commit }, payload) {
            commit('setTFA', payload);
        },
        updateTFAProcessed({ commit }, payload) {
            commit('setTFAProcessed', payload);
        },
        updatePasswordExpiry({ commit }, payload) {
            commit('setPasswordExpiry', payload);
        },
        updateCurrentAssociation({ commit }, payload) {
            commit('setCurrentAssociation', payload);
        },
        deleteInfo({ commit }) {
            commit('setUser', {
                id: 0,
                name: 'guest',
                email: 'guest@example.com',
                locale: window.default_locale,
                is_logged_in: false,
                tfa_type: '',
                is_tfa_enabled: false,
                is_company_tfa_enabled: false,
                is_association_tfa_enabled: false,
                tfa_processed: false,
                is_change_password: false,
                is_multi_association_access: false,
                module_state: false,
                modules: {
                    claimsvault: false,
                    covervault: false,
                    cia: false,
                    default: null,
                },
                association: {
                    id: 0,
                    name: '',
                    logo: null,
                    expiration_date: null,
                },
                company: {
                    id: 0,
                    name: '',
                    company_code: '',
                },
                abilities: [],
                association_list: [],
                clear_current_association: true,
                default_landing_page: '',
                enable_advanced_claims_analytics: false,
                enable_advanced_cover_analytics: false,
                claims_detail_layout: 'default',
            });
        },
    },
};
